// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/SephoraBeautyInsider.proto
import { SEPHORA_BEAUTY_INSIDER } from 'constants/amethyst';

export enum SephoraInteraction {
  JOIN_BUTTON_CLICK = 1,
  SIGN_IN_BUTTON_CLICK = 2,
  LINK_ACCOUNT_BUTTON_CLICK = 3,
  EDIT_EMAIL_BUTTON_CLICK = 4,
  RESEND_CODE_BUTTON_CLICK = 5,
  ACCOUNT_LINK_FAILED = 6,
  REGISTRATION_FAILED = 7,
  BANNER_VIEW = 8,
  UNLINK_ACCOUNT_BUTTON_CLICK = 9
}

interface SephoraBeautyInsiderEvent {
  interaction: SephoraInteraction;
}

export const evSephoraBeautyInsider = ({ interaction }: SephoraBeautyInsiderEvent) => ({
  [SEPHORA_BEAUTY_INSIDER]: {
    interaction
  }
});
